import React from 'react';
import { LanguageContextProvider } from '@unifyapps/i18n/context/LanguageProvider';
import { fallbackLng } from '@unifyapps/i18n/settings';
import userStore from '../auth/userStore';

function LocaleProvider({ children }: { children: React.ReactNode }) {
  const lng = userStore.use.currentUserDetails()?.user?.locale ?? fallbackLng;

  return <LanguageContextProvider value={lng}>{children}</LanguageContextProvider>;
}

export default LocaleProvider;
